import React from "react";
import { AlertTriangle } from "lucide-react";
import { BRAND } from "@/branding";

export const TEST_BANNER_HEIGHT = 28;

export function TestBanner() {
  if (!BRAND.banner) return null;
  return (
    <div data-testid="test-banner" role="note"
      style={{ height: TEST_BANNER_HEIGHT }}
      className="w-full shrink-0 bg-amber-400 text-slate-950 text-xs font-semibold flex items-center justify-center gap-2 px-3 tracking-wide z-[2000] relative">
      <AlertTriangle className="h-3.5 w-3.5 shrink-0" />
      <span className="truncate">{BRAND.banner}</span>
    </div>
  );
}
